var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-address-list" } }, [
    _c(
      "div",
      {
        staticClass: "to-container",
        style: _vm.label === "to" ? "height: auto" : "",
      },
      [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("div", { staticClass: "to" }, [_vm._v(_vm._s(_vm.getLabel()))]),
            _vm._v(" "),
            _vm._l(_vm.selectedMembers, function (selectedMember) {
              return _c("span", { staticClass: "selected-user-item row" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(selectedMember) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    staticClass: "material-icons closeIcon",
                    on: {
                      click: function ($event) {
                        return _vm.deleteSelectedMailAddress(
                          _vm.label,
                          selectedMember
                        )
                      },
                    },
                  },
                  [_vm._v("\n                    cancel\n                ")]
                ),
              ])
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mailValue,
                  expression: "mailValue",
                },
              ],
              staticClass: "mail-input",
              attrs: {
                autofocus: true,
                disabled:
                  _vm.label === "from" && _vm.selectedMembers.length !== 0,
              },
              domProps: { value: _vm.mailValue },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.mailValue = $event.target.value
                  },
                  function ($event) {
                    return _vm.getMailAddresses(
                      _vm.label,
                      $event,
                      _vm.label === "from"
                    )
                  },
                ],
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown",
                      ])
                    ) {
                      return null
                    }
                    return _vm.selectDown()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp",
                      ])
                    ) {
                      return null
                    }
                    return _vm.selectUp()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleEnter.apply(null, arguments)
                  },
                ],
              },
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.label === "to"
          ? _c("div", { staticClass: "buttons" }, [
              !_vm.selectedCC
                ? _c(
                    "span",
                    {
                      staticClass: "item",
                      on: {
                        click: function ($event) {
                          return _vm.changeSelectedCcOrBcc("cc")
                        },
                      },
                    },
                    [_vm._v("CC")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.selectedBCC
                ? _c(
                    "span",
                    {
                      staticClass: "item",
                      on: {
                        click: function ($event) {
                          return _vm.changeSelectedCcOrBcc("bcc")
                        },
                      },
                    },
                    [_vm._v("BCC")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.mailAddressOptions.length > 0 && _vm.optionType === _vm.label
      ? _c(
          "div",
          { staticClass: "mail-options", attrs: { id: "mailOptions" } },
          [
            _c(
              "div",
              {
                staticStyle: {
                  padding: "5px",
                  height: "fit-content",
                  "max-height": "45vh",
                  "overflow-y": "auto",
                },
              },
              _vm._l(_vm.mailAddressOptions, function (mailAddress, i) {
                return _c(
                  "div",
                  {
                    key: mailAddress._id,
                    class:
                      _vm.selectedIndex === i
                        ? "active-mail-option-key"
                        : mailAddress.type !== "seperator"
                        ? "active-mail-option-hover"
                        : "",
                    staticStyle: {
                      padding: "5px",
                      display: "flex",
                      "align-items": "center",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addItemOption(_vm.label, mailAddress.mail)
                      },
                    },
                  },
                  [
                    mailAddress.type === "seperator"
                      ? _c("div", { staticClass: "mailAddressOptionsLabels" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(mailAddress.name) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mail-list-avatar-wrapper" },
                      [
                        !!mailAddress.user
                          ? _c("AgentAvatar", {
                              attrs: {
                                size: 30,
                                "user-i-d": mailAddress.user._id,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !!mailAddress.department || !!mailAddress.visitor
                      ? _c("div", { staticClass: "avatar" }, [
                          _c("span", { staticClass: "avatar-name" }, [
                            _vm._v(
                              _vm._s(
                                mailAddress.mail
                                  ? mailAddress.mail.slice(0, 1).toUpperCase()
                                  : ""
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    mailAddress.type !== "seperator"
                      ? _c("span", [_vm._v(_vm._s(mailAddress.mail))])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }